"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IndicadorDeCarregamento = function (_a) {
  var tamanho = _a.tamanho,
    className = _a.className;
  return react_1.default.createElement("svg", {
    className: classnames_1.default("indicador-de-carregamento", className),
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: tamanho,
    height: tamanho,
    stroke: "currentColor"
  }, react_1.default.createElement("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: "current",
    strokeWidth: "10",
    r: "35",
    strokeDasharray: "164.93361431346415 56.97787143782138"
  }, react_1.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1"
  })));
};
exports.default = IndicadorDeCarregamento;